import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IDocumentType } from "../../entities/IDocumentType";
import { IDocumentCategory } from "../../entities/IDocumentCategory";
import { IDocument } from "../../entities/IDocument";

export interface Rect {
  x: number;
  y: number;
  width: number;
  height: number;
}

export interface Signature {
  id: number;
  pageIndex: number;
  rect: Rect;
  dataUrl: string;
}

interface DocumentsState {
  documentTypes: IDocumentType[];
  documentCategories: IDocumentCategory[];
  signatures: Signature[];
  isSigning: boolean;
  documentIsSuccessfullySigned: boolean;
  fetchedDocument?: IDocument;
  splitPages?: string[];
  documentBlobUrl?: string;
}

const initialState: DocumentsState = {
  documentTypes: [],
  documentCategories: [],
  signatures: [],
  isSigning: false,
  documentIsSuccessfullySigned: false,
};

export const documentsSlice = createSlice({
  name: "documents",
  initialState,
  reducers: {
    setDocumentTypes: (state: DocumentsState, action: PayloadAction<IDocumentType[]>) => {
      state.documentTypes = action.payload;
    },
    setDocumentCategories: (state: DocumentsState, action: PayloadAction<IDocumentCategory[]>) => {
      state.documentCategories = action.payload;
    },
    addSignature: (state, action: PayloadAction<Signature>) => {
      state.signatures.push(action.payload);
    },
    removeSignature: (state, action: PayloadAction<number>) => {
      state.signatures = state.signatures.filter((sig) => sig.id !== action.payload);
    },
    clearSignatures: (state) => {
      state.signatures = [];
    },
    setFetchedDocument: (state, action: PayloadAction<IDocument>) => {
      state.fetchedDocument = action.payload;
    },
    setIsSigning: (state, action: PayloadAction<boolean>) => {
      state.isSigning = action.payload;
    },
    setSplitPages: (state, action: PayloadAction<string[]>) => {
      state.splitPages = action.payload;
    },
    setDocumentSuccessfullySignedStatus: (state, action: PayloadAction<boolean>) => {
      state.documentIsSuccessfullySigned = action.payload;
    },
    setDocumentBlobUrl: (state, action: PayloadAction<string>) => {
      state.documentBlobUrl = action.payload;
    },
  },
});

export const documentsActions = documentsSlice.actions;

export default documentsSlice.reducer;
